<template>
  <div v-for="(section, index) in MenuFooterLinksInstance" :key="index">
    <MenuFooterLinksSection :section="section" />
  </div>
</template>

<script setup lang="ts">
import { useMenuFooter } from '../composables/useMenuFooter'

const { MenuFooterLinksInstance } = await useMenuFooter()
</script>
